export enum EditLayoutCallableViewEnum {
    ContractControl = 'contract_control',
    DocumentTypeSetting = 'document_type_setting',
    ContractControlAddon = 'contract_control_addon',
    AddDocumentType = 'add_document_type'
}